<template>

<div :class="{hasError:isError}" style="width: 100%;"> 
    <DataTable :value="value" dataKey="MFGSearchTerm" :disabled="disabled" >
      <Column field="IsSelect" header="IsSelect">
             <template #body="slotProps">
                 <Checkbox v-model="slotProps.data.IsSelect" :binary="true" :disabled="disabled" />          
             </template>
     </Column>
     <Column field="MFGSearchTerm" header="Search Term" bodyStyle="padding: 0rem 1rem;" headerStyle="padding: 0.5rem 1rem;"></Column>
     <Column field="MFGName" header="Name" bodyStyle="padding: 0rem 1rem;" headerStyle="padding: 0.5rem 1rem;"></Column>
  </DataTable>
 

</div>

</template>  
<script>
 


import Service from "../../service/service";
import SapService from "../../service/SapService";


export default {
    props: ["modelValue", 'disabled'],
    emits: ["update:modelValue"],
    data() {
        return {
            value:[],
        }
    },
    Service: null,
    SapService: null,
    
    created() {
        this.Service = new Service();
        this.SapService = new SapService();
         this.value=this.modelValue;
       
    },
    methods: {
        
        

    },
    watch: {
        value: function () {
              // watch it
             // console.log("value Prop changed: ", this.value);
              this.$emit("update:modelValue", this.value );
            },
       
    },
    computed: {
      isError() {
            return   !this.disabled &&  this.value.filter(x=>x.IsSelect==true).length==0     ;
    },
    isLoading() {
      return this.$store.state.isLoading;
      //return false;
    },
    user() {
     return this.$store.state.user;
    },
    user_userName() {
     return this.$store.state.user?.userName;
    },
    user_buyerMapping() {
     return this.$store.state.user?.buyerMapping;
    },
    user_sourcerMapping() {
     return this.$store.state.user?.sourcerMapping;
    },
    user_vendorMapping() {
     return this.$store.state.user?.vendorMapping;
    },
    user_mfgcode() {
     return this.$store.state.user?.mfgcode;
    },
    user_mfgsearchterm() {
     return this.$store.state.user?.mfgsearchterm;
    },
    user_roles() {
     return this.$store.state.user?.Roles;
    },
    clientId() {
     return this.$store.state.user?.clientId;
    },


    is_VIPAdmin(){
       return this.user_roles && this.user_roles.includes('VIPAdmin');
    },
    is_SCSI(){
       return this.user_roles && this.user_roles.includes('SCSI');
    },
    is_Sourcer(){
       return this.user_roles && this.user_roles.includes('Sourcer');
    },
    is_Buyer(){
       return this.user_roles && this.user_roles.includes('Buyer');
    },
    is_CompalUser(){
       return this.user_roles && this.user_roles.includes('CompalUser');
    },
    is_VendorUser(){
       return this.user_roles && this.user_roles.includes('VendorUser');
    },
    is_Supervisor(){
       return this.user_roles && this.user_roles.includes('Supervisor');
    },
    token() {
     return this.$store.state.token;
    },
    refreshToken() {
     return this.$store.state.refreshToken;
    },
    sessionCode() {
     return this.$store.state.sessionCode;
    },


     

  },
}
</script>
  
 
<style scoped>
.hasError label {
  color:red;
  border-color: red;
  border-width: thin;
}
.hasError  {
  color:red;
  border-color: red;
  border-width: thin;
  border: 1px solid;
  border-radius: 5px;
}
</style>